import { DashboardLayout } from "@/components/layouts/DashboardLayout";
import { HelpContent } from "@/components/help/HelpContent";

export default function Help() {
  return (
    <DashboardLayout>
      <div className="page-container">
        <HelpContent />
      </div>
    </DashboardLayout>
  );
}